import { MobileNumberField } from '../numberField/models';

export const MobileStopwatchField = MobileNumberField.extend({
    start_date: null,

    validation: {
        value: {
            fn: function (val, attr, computed) {
                if (!val && this._is_required(val, attr, computed)) {
                    return _t('mobile_message_error_stopwatch_field_required');
                }
                if (!val && this.start_date) {
                    return _t('mobile_message_error_stopwatch_field_running');
                }
            }
        }
    },

    initialize: function () {
        var this_ = this;

        $f.mobile.settings.get('stopwatch_start_date_' + this.id, function (value) {
            this_.start_date = value ? value.start_date : null;
            if (this_.start_date) {
                this_.trigger('stopwatch_changed');
            }
        });

        MobileStopwatchField.__super__.initialize.apply(this, arguments);
    },

    start_stopwatch: function (interval_id) {
        if (!this.start_date) {
            this.start_date = moment().valueOf();

            // we need to mark the form as started but we don't want to trigger validation on this field if it's not ready.
            if (this.collection) {
                this.collection.trigger('change', this.collection);
            }
        }

        $f.mobile.settings.set('stopwatch_start_date_' + this.id, {
            start_date: this.start_date
        });
    },

    stop_stopwatch: function (value) {
        this.set({ value: value }, { silent: true });
        this.start_date = null;
        $f.mobile.settings.remove('stopwatch_start_date_' + this.id);
    },

    reset_stopwatch: function () {
        this.set('value', '');
    }
});
